export default __webpack_public_path__ + "static/media/livbrite-blog-all.422f4c3b.jpg";